import { getWorkshops } from "src/services/maintenanceRepair";
import { formatErrorMessage } from "src/utils/misc";

export function workshopOptionsFrom(
	workshops: { id: number; name: string }[] = []
) {
	return workshops.map((workshop) => ({
		label: workshop.name,
		value: workshop.id,
	}));
}

export async function loadWorkshopCatalog() {
	try {
		const res = await getWorkshops();
		return { options: workshopOptionsFrom(res.data), error: "" };
	} catch (error) {
		console.error(error);
		return {
			options: [],
			error: formatErrorMessage(error) || "Couldn't load workshops.",
		};
	}
}

export async function searchWorkshopCatalog(
	filterText: string,
	fallbackOptions: { label: string; value: number }[]
) {
	if (!filterText) return { options: fallbackOptions, error: "" };
	try {
		const res = await getWorkshops(filterText);
		return { options: workshopOptionsFrom(res.data), error: "" };
	} catch (error) {
		console.error(error);
		return {
			options: [],
			error: formatErrorMessage(error) || "Couldn't search workshops.",
		};
	}
}

// svelte-select applies every resolved loadOptions result: a superseded search
// returns { cancelled: true }, or the full catalog once the field is cleared.
export function createWorkshopSearch({
	getFilterText,
	getFallbackOptions,
	onError,
}: {
	getFilterText: () => string;
	getFallbackOptions: () => { label: string; value: number }[];
	onError: (error: string) => void;
}) {
	let generation = 0;
	return {
		invalidate() {
			generation++;
		},
		async search(filterText: string) {
			const current = ++generation;
			const { options, error } = await searchWorkshopCatalog(
				filterText,
				getFallbackOptions()
			);
			if (current !== generation || filterText !== getFilterText()) {
				if (getFilterText()) return { cancelled: true };
				onError("");
				return getFallbackOptions();
			}
			onError(error);
			return options;
		},
	};
}
